import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  heading: {
    id: 'frontbucket.repository.pullrequest.forgeEnabledOnMergeChecks.heading',
    description: 'Remaining merge checks section heading',
    defaultMessage:
      'Remaining {total, plural, one {check} other {checks}} will run on merge',
  },
  description: {
    id: 'frontbucket.repository.pullrequest.forgeEnabledOnMergeChecks.description',
    description: 'Description for remaining merge checks section',
    defaultMessage:
      'The following {total, plural, one {check} other {checks}} will run on merge. If {total, plural, one {the required on-merge check} other {one of the required on-merge checks}} fails during the merge process, you will be notified and need to resolve any issues before attempting to merge again.',
  },
  errorTitle: {
    id: 'frontbucket.repository.pullrequest.forgeEnabledOnMergeChecks.errorTitle',
    description: 'Title for error while fetching on-merge checks',
    defaultMessage: 'Failed to load',
  },
  errorText: {
    id: 'frontbucket.repository.pullrequest.forgeEnabledOnMergeChecks.errorText',
    description: 'Text for error while fetching on-merge checks',
    defaultMessage:
      'Something went wrong when attempting to load your custom merge checks. Refresh to try again.',
  },
  retry: {
    id: 'frontbucket.repository.pullrequest.forgeEnabledOnMergeChecks.retry',
    description:
      'Text for retry action on error while fetching on-merge checks',
    defaultMessage: 'Refresh',
  },
  checkTargetBranchLabel: {
    id: 'frontbucket.repository.pullrequest.forgeEnabledOnMergeChecks.checkTargetBranchLabel',
    description: 'Label for the target branch of the merge check',
    defaultMessage: '(targeting {branchName} branch)',
  },
});
